export const convertQueryStringToObject = (search: string): {} => {
  const pairs: string[] = search?.slice(1)?.split('&');

  const result = {};
  pairs.forEach((pair) => {
    const params = pair?.split('=');
    result[params[0]] = decodeURIComponent(params[1] || '');
  });

  return JSON.parse(JSON.stringify(result));
};
